import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://192.168.29.116:8080"; 

export const login = async (username, password) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/Authentication/token`, {
            username,
            password,
        });

        if (response.status === 200 && response.data.success) {
            return response.data; // ✅ Return full API response
        } else {
            throw new Error("Login failed");
        }
    } catch (error) {
        console.error("❌ API Login Error:", error);
        throw error;
    }
};
